import classNames from "classnames";

import styles from "./ModalHeading.module.scss";

import type { ModalHeadingProps } from "../model/types";

export const ModalHeading = ({ text, className }: ModalHeadingProps) => {
    return <h3 className={classNames(styles.heading, className)}>{text}</h3>;
};
